import React from 'react';
import { useSelector } from 'react-redux';
import FactoryAuthContent from './FactoryAuthContent';
import { AuthBoxContainer } from './AuthList.css';

const SafetyAuthBox = ({ auths, selectAuth, setSelectAuth }) => {
  return (
    <AuthBoxContainer>
      <div className="title">공장관리자</div>
      <div className="content-box">
        {auths
          .filter((auth) => auth.level === 3)
          .map((factoryAuth) => {
            return (
              <FactoryAuthContent
                childsAuth={auths.filter((_auth) => _auth.level === 4 && _auth.parentAuth === factoryAuth.authIdx)}
                factoryAuth={factoryAuth}
                selectAuth={selectAuth}
                setSelectAuth={setSelectAuth}
              />
            );
          })}
      </div>
    </AuthBoxContainer>
  );
};

export default SafetyAuthBox;
